<ul>
  <li *ngFor="let item of providers">
    <div fxLayoutAlign="center center" fxLayout="column">
      <span class="social-icon-holder circle border" (click)="_socialLogin(item)" [title]="item | titlecase">
        <span *ngIf="item !=  'netid_qa'" class="social-icon" [ngClass]="'cidaas-icon-'+item"></span>
        <span *ngIf="item ===  'netid_qa'" class="social-icon" [ngClass]="'cidaas-icon-netid'"></span>
      </span>
      <label *ngIf="item !=  'netid_qa'" >{{item | titlecase}}</label>
      <label *ngIf="item ===  'netid_qa'" >{{'netid qa' | titlecase}}</label>
    </div>
  </li>
</ul>
<div *cidContentLoader="contentLoading"></div>
